import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationService } from '@common/services/navigation-service';
import { NavigationGroup, NavigationGroupTypes, NavigationSection } from '@common/store/navigation/models/navigation.models';
import { Store } from '@ngrx/store';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { LanguageSettings } from '@src/suite/common/services/language-settings';
import { selectGroups } from '@src/suite/common/store/navigation/selectors/navigation.selectors';
import { map } from 'rxjs';

@Component({
    selector: 'st-add-view-to-navigation',
    templateUrl: './add-view-to-navigation.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-add-view-to-navigation',
    },
    styleUrls: ['./add-view-to-navigation.scss'],
})
export class AddViewToNavigationComponent {
    groups$ = this.store.select(selectGroups).pipe(
        map((groups: Array<NavigationGroup>) => {
            if (this.isSupervisor && !this.isPersonalView) {
                return groups
                    .map((group: NavigationGroup) => {
                        if (group.id === NavigationGroupTypes.Team) {
                            group.label = this.globalTablesService.Groups[this.globalTablesService.nomWebServicesJson.HelloResults.HomeProgram]?.Description || group.label;
                        }
                        return group;
                    })
                    .filter((group: NavigationGroup) => {
                        return group.id !== NavigationGroupTypes.System;
                    });
            } else {
                return groups.filter((group: NavigationGroup) => {
                    return group.id === NavigationGroupTypes.Personal;
                });
            }
        })
    );

    constructor(
        public dialogRef: MatDialogRef<AddViewToNavigationComponent>,
        public navigationService: NavigationService,
        public globalTablesService: GlobalTablesService,
        public languageSettings: LanguageSettings,
        private store: Store,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            isSupervisor: boolean;
            isPersonalView: boolean;
        }
    ) {
        if (data.isSupervisor) this.isSupervisor = true;
        if (data.isPersonalView) this.isPersonalView = true;
    }

    get sections(): Array<NavigationSection> {
        if (this.selectedGroup) {
            return this.selectedGroup.items;
        }
        return null;
    }

    get isConfirmDisabled(): boolean {
        return !this.selectedGroup || !this.selectedSection;
    }

    public isSupervisor: boolean = false;
    public isPersonalView: boolean = false;
    public isGroupSelected: boolean = false;
    public selectedGroup: NavigationGroup;
    public selectedSection: NavigationSection;

    public onSelectionChange() {
        if (this.selectedGroup) {
            this.isGroupSelected = true;
        } else {
            this.isGroupSelected = false;
        }
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    onConfirmClick(): void {
        this.dialogRef.close({
            group: this.selectedGroup.id,
            section: this.selectedSection[0].id,
        });
    }
}
